import { beforeEnterBimex, beforeEnterPrintDesign } from "../method/method";
export default [
  // 文件批注
  {
    path: "/dwgpro",
    name: "dwgpro",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/dwgProMax/index.vue")
  },
  {
    path: "/modelpro",
    name: "modelpro",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/modelProMax/index.vue")
  },
  {
    path: "/cmnPdf",
    name: "cmnPdf",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/docmentView/pdf.vue"),
    hidden: true
  },
  {
    path: "/cmnTxt",
    name: "cmnTxt",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/docmentView/txt.vue"),
    hidden: true
  },
  {
    path: "/cmnOffice",
    name: "cmnOffice",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/docmentView/office.vue"),
    hidden: true
  },

  {
    path: "/cmnImage",
    name: "cmnImage",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/docmentView/image.vue"),
    hidden: true
  },
  {
    path: "/cmnMp4",
    name: "cmnMp4",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/docmentView/mp4.vue"),
    hidden: true
  },
  {
    path: "/printDesignDoc",
    name: "printDesignDoc",
    beforeEnter: beforeEnterPrintDesign,
    component: () => import("@/CommonDP/mongeView/printDesign/index.vue")
  }
];
